module.exports = __webpack_public_path__ + "static/media/lighthouse-logo.0c93876f.png";